module.exports = __webpack_public_path__ + "static/media/slide3.bef1ba31.png";